// Navigation only: entitlement is confirmed by the existing authenticated status API.
function startCheckoutActivation({refresh,onState,onConfirmed,schedule=setTimeout,cancel=clearTimeout,maxAttempts=20,delay=3000}){
  let stopped=false,timer=null,attempts=0;
  async function check(){
    if(stopped)return;
    attempts++;
    onState('checking');
    let status;
    try{status=await refresh();}catch{status=null;}
    if(stopped)return;
    if(status?.is_pro===true&&status.billing_status!=='unavailable'){
      stopped=true;
      onConfirmed();
      return;
    }
    if(attempts>=maxAttempts){onState('waiting');return;}
    onState('processing');
    timer=schedule(check,delay);
  }
  check();
  return ()=>{stopped=true;if(timer!==null)cancel(timer);};
}
module.exports={startCheckoutActivation};
